import { Navigate, RouteObject } from "react-router";

import { NewPolicyRoutes } from "./paths";

import { SelectProductStep } from "./routes/NewBusiness/SelectProductStep";
import { HomeAddressStep } from "./routes/NewBusiness/HomeAddressStep";
import { HomeDetailsStep } from "./routes/NewBusiness/HomeDetailsStep";
import { PersonalDetailsStep } from "./routes/NewBusiness/PersonalDetailsStep";
import { PersonalizedQuotesStep } from "./routes/NewBusiness/PersonalizedQuotesStep";
import { ExtraCoveragesStep } from "./routes/NewBusiness/ExtraCoveragesStep";
import { UnderwritingQuestionsStep } from "./routes/NewBusiness/UnderwritingQuestionsStep";
import ClaimsCheckStep from "./routes/NewBusiness/ClaimsCheckStep";
import { ClaimsListStep } from "./routes/NewBusiness/ClaimsListStep";
import { PolicySummaryStep } from "./routes/NewBusiness/PolicySummaryStep";
import { PolicyCustomizationStep } from "./routes/NewBusiness/PolicyCustomizationStep";
import { UWReviewStep } from "./routes/NewBusiness/UWReviewStep";
import { FastUWStep } from "./routes/NewBusiness/FastUWStep";
import { DeclinePropertyStep } from "./routes/NewBusiness/DeclinePropertyStep";
import { CheckoutStep } from "./routes/NewBusiness/CheckoutStep";
import { CongratulationsStep } from "./routes/NewBusiness/CongratulationsStep";
import { ErrorStep } from "./routes/NewBusiness/ErrorStep";
import { UnitCountStep } from "./routes/NewBusiness/UnitCountStep/UnitCountStep";

export const newPolicyRoutes: RouteObject[] = [
  {
    path: "*",
    element: <Navigate to={`${NewPolicyRoutes.SELECT_PRODUCT}`} />,
  },
  {
    path: NewPolicyRoutes.SELECT_PRODUCT,
    element: <SelectProductStep />,
  },
  {
    path: NewPolicyRoutes.UNIT_COUNT,
    element: <UnitCountStep />,
  },
  {
    path: NewPolicyRoutes.HOME_ADDRESS,
    element: <HomeAddressStep />,
  },
  {
    path: NewPolicyRoutes.HOME_DETAILS,
    element: <HomeDetailsStep />,
  },
  {
    path: NewPolicyRoutes.PERSONAL_DETAILS,
    element: <PersonalDetailsStep />,
  },
  {
    path: NewPolicyRoutes.PERSONALIZED_QUOTES,
    element: <PersonalizedQuotesStep />,
  },
  {
    path: NewPolicyRoutes.EXTRA_COVERAGES,
    element: <ExtraCoveragesStep />,
  },
  {
    path: NewPolicyRoutes.UNDERWRITING_QUESTIONS,
    element: <UnderwritingQuestionsStep />,
  },
  {
    path: NewPolicyRoutes.CLAIMS_CHECK,
    element: <ClaimsCheckStep />,
  },
  {
    path: NewPolicyRoutes.CLAIMS_LIST,
    element: <ClaimsListStep />,
  },
  {
    path: NewPolicyRoutes.POLICY_SUMMARY,
    element: <PolicySummaryStep />,
  },
  {
    path: NewPolicyRoutes.CUSTOMIZE_POLICY,
    element: <PolicyCustomizationStep />,
  },
  {
    path: NewPolicyRoutes.UNDERWRITING_REVIEW,
    element: <UWReviewStep />,
  },
  {
    path: NewPolicyRoutes.FAST_DECLINE,
    element: <FastUWStep />,
  },
  {
    path: NewPolicyRoutes.DECLINE_PROPERTY,
    element: <DeclinePropertyStep />,
  },
  {
    path: NewPolicyRoutes.CHECKOUT,
    element: <CheckoutStep />,
  },
  {
    path: NewPolicyRoutes.CONGRATULATIONS,
    element: <CongratulationsStep />,
  },
  {
    path: NewPolicyRoutes.ERROR,
    element: <ErrorStep />,
  },
];
